import useAppStore from "@/context/store";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";

export const TAB = {
  BOARDS: "",
  PINS: "pins",
  CREATED: "created",
  CREATIONS: "creations",
  LIKES: "likes",
  TAGS: "tags",
  LESSONS: "lessons",
  RECYCLE: "recycle",
};

export default function ViewModel({ openTab, user, tagName: _tagName }) {
  const userStore = useAppStore(({ user, userReady, config, lastBoards }) => ({
    user,
    userReady,
    config,
    lastBoards,
  }));
  const [currentTab, setCurrentTab] = useState(openTab ?? TAB.BOARDS);
  const [tagName, setTagName] = useState(_tagName);
  const router = useRouter();

  useEffect(() => {
    const { openTab, tagName } = router.query;
    setCurrentTab(openTab || TAB.BOARDS);
    setTagName(tagName);
  }, [router.query]);

  return {
    currentTab,
    user,
    userStore,
    tagName,
  };
}
